<template>
  <router-link
    :to="{name: 'player_ban', params: {playerId: playerId, banId: banId}}"
  >
    {{lable}} {{banId}}
  </router-link>
</template>

<script>
export default {
  name: 'PlayerBanLink',

  props: {
    playerId: {
      type: Number,
      required: true,
    },

    banId: {
      type: Number,
      required: true,
    },

    lable: {
      type: String,
      default: 'Ban'
    }
  },
};
</script>
